import React from 'react';

export default function Formlar() {
  const ulasimHavaalaniLink = "https://forms.gle/TLvnr2ioVoihAHv3A"; 
  const kahramanlarParkuruLink = "https://docs.google.com/forms/d/e/1FAIpQLScr07RpNyIwEhbI6mH2ZMTU95-mww9Y7qMM-y1A1NS7oRXF_A/viewform?usp=publish-editor";
  const plajVoleyboluLink = "https://docs.google.com/forms/d/e/1FAIpQLSfSyWte9nnTk3R_6Ex0kYCraEO9kPdk43buwchFqo-v7sfrfA/viewform?usp=dialog";

  return (
    <section className="py-5 formlar-page" style={{ paddingTop: '150px' }}>
      <div className="container">
        <h1 className="text-center mb-5" style={{ marginTop: '50px', color: '#fff' }}>Formlar</h1>
        
        <div className="row justify-content-center gap-4">
          
          {/* Ulaşım Formu Kartı */}
          <div className="col-lg-5 col-md-10">
            <div 
              className="card h-100 overflow-hidden" 
              style={{ 
                backgroundColor: 'rgba(34, 13, 28, 0.9)', 
                color: '#fff', 
                border: '1px solid rgba(255, 255, 255, 0.1)', 
                borderRadius: '15px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.3)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div 
                className="card-img-top d-flex flex-column align-items-center justify-content-center"
                style={{
                  aspectRatio: '4 / 5',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  position: 'relative',
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: '#000'
                }}
              >
                <img 
                  src="/images/ulasim_formu.webp" 
                  alt="Ulaşım Formu" 
                  style={{width: '100%', height: '100%', objectFit: 'contain'}} 
                />
              </div>
              <div className="card-body text-center p-4 d-flex flex-column">
                <h4 className="card-title mb-3" style={{ color: '#db9e37' }}>Ulaşım Formu</h4>
                <p className="card-text mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  Masala giden yolculuk burada başlıyor.<br /><br />
                  Havaalanı ulaşım kaydını oluşturarak ulaşımını şimdiden planla!
                </p>
                <div className="mt-auto row gx-2">
                  <div className="col-12">
                    <a 
                      href={ulasimHavaalaniLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn w-100 px-1"
                      style={{
                        height: '55px',
                        backgroundColor: '#db9e37',
                        color: '#fff',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        fontSize: '12px'
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-airplane flex-shrink-0" viewBox="0 0 16 16">
                        <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Zm.894.448C7.111 2.02 7 2.569 7 3v4a.5.5 0 0 1-.276.447l-5.448 2.724a.5.5 0 0 0-.276.447v.792l5.418-.903a.5.5 0 0 1 .575.41l.5 3a.5.5 0 0 1-.14.437L6.708 15h2.586l-.647-.646a.5.5 0 0 1-.14-.436l.5-3a.5.5 0 0 1 .576-.411L15 11.41v-.792a.5.5 0 0 0-.276-.447L9.276 7.447A.5.5 0 0 1 9 7V3c0-.432-.11-.98-.322-1.401C8.458 1.159 8.213 1 8 1c-.213 0-.458.158-.678.599Z"/>
                      </svg>
                      <span className="text-start" style={{lineHeight: 1.2}}>Havaalanı Ulaşımı</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Takım Oyunları Formu Kartı */}
          <div className="col-lg-5 col-md-10">
            <div 
              className="card h-100 overflow-hidden" 
              style={{ 
                backgroundColor: 'rgba(34, 13, 28, 0.9)', 
                color: '#fff', 
                border: '1px solid rgba(255, 255, 255, 0.1)', 
                borderRadius: '15px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.3)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div 
                className="card-img-top d-flex flex-column align-items-center justify-content-center"
                style={{
                  aspectRatio: '4 / 5',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  position: 'relative',
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: '#000'
                }}
              >
                <img 
                  src="/images/kahramanlar_arenasi.webp" 
                  alt="Takım Oyunları" 
                  style={{width: '100%', height: '100%', objectFit: 'contain'}} 
                />
              </div>
              <div className="card-body text-center p-4 d-flex flex-column">
                <h4 className="card-title mb-3" style={{ color: '#db9e37' }}>Kahramanlar Arenası Kayıt Formu</h4>
                <p className="card-text mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  Kahramanlar Arenası’nda yerini almak için kayıt ol!<br /><br />
                  Plaj Voleybolu ve Kahramanlar Parkuru'nda takımınla mücadele et, masalın ana karakteri sen ol!
                </p>
                <div className="mt-auto row gx-2">
                  <div className="col-6">
                    <a 
                      href={kahramanlarParkuruLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn w-100 px-1"
                      style={{
                        height: '55px',
                        backgroundColor: '#db9e37',
                        color: '#fff',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        fontSize: '12px'
                      }}
                    >
                      <span className="flex-shrink-0" style={{fontSize: '18px'}}>🏃‍♂️</span> 
                      <span className="text-start" style={{lineHeight: 1.2}}>Kahramanlar Parkuru</span>
                    </a>
                  </div>
                  <div className="col-6">
                    <a 
                      href={plajVoleyboluLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn w-100 px-1"
                      style={{
                        height: '55px',
                        backgroundColor: '#db9e37', 
                        color: '#fff', 
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        fontSize: '12px'
                      }}
                    >
                      <span className="flex-shrink-0" style={{fontSize: '18px'}}>🏐</span> 
                      <span className="text-start" style={{lineHeight: 1.2}}>Plaj Voleybolu</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
